<template>
  <div class="timepicker">
    <ul class="list-inline text-center mx-1 px-4 mb-0">
      <li
        v-for="(day, index) in daysOfWeek"
        :key="index"
        @click="changeDay(index)"
        :class="'font-button day list-inline-item mx-2' + (index === selectedDayOfWeek ? ' active' : '')"
      >{{day.short}}</li>
    </ul>
    <div class="px-1 py-2 d-flex justify-content-between align-items-center">
      <span @click="prevDay()" class="p-2 font-button"><FontAwesomeIcon icon="chevron-left" /></span>
      <span>{{daysOfWeek[selectedDayOfWeek].upperCaseName}}</span>
      <span @click="nextDay()" class="p-2 font-button"><FontAwesomeIcon icon="chevron-right" /></span>
    </div>
  </div>
</template>

<script>
import days from '@/utils/days'

export default {

  name: 'DaysOfWeekPicker',

  props: {
    onChange: Function
  },

  created () {},

  data () {
    return {
      selectedDayOfWeek: 0,
      daysOfWeek: days
    }
  },

  methods: {

    changeDay (index) {
      this.selectedDayOfWeek = index
      if (this.onChange) { this.onChange(this.selectedDayOfWeek) }
    },

    nextDay () {
      if (this.selectedDayOfWeek === 6) {
        this.selectedDayOfWeek = 0
      } else {
        this.selectedDayOfWeek++
      }
      if (this.onChange) { this.onChange(this.selectedDayOfWeek) }
    },

    prevDay () {
      if (this.selectedDayOfWeek === 0) {
        this.selectedDayOfWeek = 6
      } else {
        this.selectedDayOfWeek--
      }
      if (this.onChange) { this.onChange(this.selectedDayOfWeek) }
    }
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/DaysOfWeekPicker.vue